import {
    DraftInvoicesByCaseRow,
    DraftInvoicesByCaseTotals,
    InvoicedHourlyRatesRow,
    InvoiceTotalsByAccountingTypeRow,
    InvoiceTotalsByPayerCountryRow,
    InvoiceTotalsReportTotals,
    RevenueByEmployeeRow,
    RevenueByEmployeeTotals,
} from 'types/reporting/finance';
import { ReportPage } from 'types/reporting/reportPage';
import { portalAPI } from './portalAPI';
import { reportQuery } from './util/reportQuery';

const reportingFinanceApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getRevenueByEmployeeReport: reportQuery<ReportPage<RevenueByEmployeeRow, RevenueByEmployeeTotals>>(
            builder,
            '/v1/reporting/revenue-by-employee'
        ),
        getInvoicedHourlyRatesReport: reportQuery<ReportPage<InvoicedHourlyRatesRow, null>>(
            builder,
            '/v1/reporting/invoiced-hourly-rates-by-employee-and-case'
        ),
        getInvoiceTotalsByAccountingTypeReport: reportQuery<
            ReportPage<InvoiceTotalsByAccountingTypeRow, InvoiceTotalsReportTotals>
        >(builder, '/v1/reporting/invoice-totals-by-accounting-type'),
        getInvoiceTotalsByPayerCountryReport: reportQuery<
            ReportPage<InvoiceTotalsByPayerCountryRow, InvoiceTotalsReportTotals>
        >(builder, '/v1/reporting/invoice-totals-by-payer-country'),
        getDraftInvoicesByCaseReport: reportQuery<ReportPage<DraftInvoicesByCaseRow, DraftInvoicesByCaseTotals>>(
            builder,
            '/v1/reporting/draft-invoices-by-case'
        ),
    }),
});

export const {
    useLazyGetRevenueByEmployeeReportQuery,
    useLazyGetInvoicedHourlyRatesReportQuery,
    useLazyGetInvoiceTotalsByAccountingTypeReportQuery,
    useLazyGetInvoiceTotalsByPayerCountryReportQuery,
    useLazyGetDraftInvoicesByCaseReportQuery,
} = reportingFinanceApi;
